/* eslint-disable */
export default {
  schedule: 'Programar reunión',
  prompt: 'Autorice a RingCentral a acceder a la información de cuenta.',
  saveAsDefault: 'Guardar como predeterminado',
  launchMeeting: 'Iniciar reunión',
} as const;

// @key: @#@"schedule"@#@ @source: @#@"Schedule Meeting"@#@
// @key: @#@"prompt"@#@ @source: @#@"Please authorize RingCentral to access your account information."@#@
// @key: @#@"saveAsDefault"@#@ @source: @#@"Save as default"@#@
// @key: @#@"launchMeeting"@#@ @source: @#@"Launch Meeting"@#@
